import {Inject, injectable} from 'inversify-props';

import {INetworkProfileService} from '@/services/network/INetworkProfileService';
import {IApiService} from '@/services/IApi.service';

import {Profile} from '@/model/network/profile/Profile';
import {ProfileSettings} from '@/model/network/settings/ProfileSettings';
import {Connection} from '@/model/network/connection/Connection';

@injectable()
export class NetworkProfileService implements INetworkProfileService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/network/profile';

  public async create(profile: any): Promise<Profile> {
    return Profile.Serializer.parse(await this.apiService.post(this.path, Profile.Serializer.toPlainJson(profile)))!;
  }

  public async import(profileName: string, type: string, configuration: string[], settings: ProfileSettings): Promise<Profile> {
    return Profile.Serializer.parse(await this.apiService.post(`${this.path}/import`, {
      profileName,
      type,
      configuration,
      settings: ProfileSettings.Serializer.toPlainJson(settings),
    }))!;
  }

  public async readAll(): Promise<Profile[]> {
    const profilesData = await this.apiService.get(this.path);
    return profilesData.map((p: any) => Profile.Serializer.parse(p));
  }

  public async read(id: string): Promise<Profile> {
    return Profile.Serializer.parse(await this.apiService.get(`${this.path}/${id}`))!;
  }

  public async update(id: string, profile: Profile): Promise<Profile> {
    return Profile.Serializer.parse(await this.apiService.put(
      `${this.path}/${id}/update`,
      ProfileSettings.Serializer.toPlainJson(profile.Settings),
    ))!;
  }

  public async delete(id: string): Promise<void> {
    return this.apiService.delete(`${this.path}/${id}`);
  }

  public async connect(id: string): Promise<Connection> {
    return Connection.Serializer.parse(await this.apiService.post(`${this.path}/${id}/connect`, null))!;
  }
}
